module.exports = __webpack_public_path__ + "static/media/1_Sign_In.37e31fdf.jpg";